<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 179 179"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>beauty-spenders</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle
        id="path-1"
        cx="89.2666667"
        cy="89.2666667"
        r="88.8888889" />
      <circle
        id="path-3"
        cx="89.2666667"
        cy="89.2666667"
        r="88.8888889" />
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-898.000000, -635.000000)">
        <g
          id="beauty-spenders"
          transform="translate(898.000000, 635.000000)">
          <g id="Scene">
            <mask
              id="mask-2"
              fill="white">
              <use xlink:href="#path-1" />
            </mask>
            <g
              id="Oval"
              fill-rule="nonzero" />
            <mask
              id="mask-4"
              fill="white">
              <use xlink:href="#path-3" />
            </mask>
            <use
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              xlink:href="#path-3" />
            <path
              id="Path"
              d="M84.4445801,92.0666667 C84.4657158,88.0906396 81.9830634,84.5312814 78.2444444,83.1777778 C78.6814871,82.293167 78.9095697,81.3200147 78.9111111,80.3333333 C78.8954527,79.6524182 78.7755425,78.9779234 78.5555556,78.3333333 C81.1774947,76.3223122 82.5509666,73.0822938 82.1730717,69.7996171 C81.7951769,66.5169404 79.72142,63.6737597 76.7111111,62.3111111 L76.7111111,61.5333333 C76.7111111,46.7555556 63.8,35.8888889 49.0222222,35.8666652 C34.5595155,35.86184 22.7291747,47.3865636 22.3555556,61.8444444 C18.9789361,62.8484816 16.4498312,65.6601609 15.807708,69.1238767 C15.1655847,72.5875925 16.5187735,76.1189934 19.3111111,78.2666667 C19.0962434,78.9118367 18.9837689,79.5866839 18.9777778,80.2666667 C18.9800196,81.2507581 19.2001003,82.2221488 19.6222222,83.1111111 C15.7094621,84.4976222 13.1738344,88.2915735 13.3893214,92.4371337 C13.6048085,96.582694 16.5201287,100.093304 20.5555556,101.066667 C20.2076948,101.882641 20.0191214,102.757621 20,103.644444 C20,107.326343 22.9847683,110.311111 26.6666667,110.311111 L27.0666667,110.311111 C28.0061073,112.968286 30.5149891,114.747635 33.3333333,114.755556 L33.4444444,114.755556 C33.9318752,117.626408 36.2261846,119.848739 39.1111111,120.244444 C41.3333333,130.444444 56.3111111,130.955556 58.6444444,120.244444 C61.5673549,119.908303 63.9243107,117.695835 64.4444444,114.8 L64.4444444,114.8 C67.2627887,114.792079 69.7716704,113.01273 70.7111111,110.355556 L71.1111111,110.355556 C74.7930094,110.355556 77.7777778,107.370787 77.7777778,103.688889 C77.7784507,102.82814 77.6124316,101.975405 77.2888889,101.177778 C81.4799666,100.139073 84.42867,96.3845124 84.4445801,92.0666667 Z"
              class="fill-white"
              fill-rule="nonzero"
              mask="url(#mask-4)" />
            <path
              id="Path"
              d="M84.4445801,92.0666667 C84.4657158,88.0906396 81.9830634,84.5312814 78.2444444,83.1777778 C78.6814871,82.293167 78.9095697,81.3200147 78.9111111,80.3333333 C78.8954527,79.6524182 78.7755425,78.9779234 78.5555556,78.3333333 C81.1774947,76.3223122 82.5509666,73.0822938 82.1730717,69.7996171 C81.7951769,66.5169404 79.72142,63.6737597 76.7111111,62.3111111 L76.7111111,61.5333333 C76.7111111,46.7555556 63.8,35.8888889 49.0222222,35.8666652 C34.5595155,35.86184 22.7291747,47.3865636 22.3555556,61.8444444 C18.9789361,62.8484816 16.4498312,65.6601609 15.807708,69.1238767 C15.1655847,72.5875925 16.5187735,76.1189934 19.3111111,78.2666667 C19.0962434,78.9118367 18.9837689,79.5866839 18.9777778,80.2666667 C18.9800196,81.2507581 19.2001003,82.2221488 19.6222222,83.1111111 C15.7094621,84.4976222 13.1738344,88.2915735 13.3893214,92.4371337 C13.6048085,96.582694 16.5201287,100.093304 20.5555556,101.066667 C20.2076948,101.882641 20.0191214,102.757621 20,103.644444 C20,107.326343 22.9847683,110.311111 26.6666667,110.311111 L27.0666667,110.311111 C28.0061073,112.968286 30.5149891,114.747635 33.3333333,114.755556 L33.4444444,114.755556 C33.9318752,117.626408 36.2261846,119.848739 39.1111111,120.244444 C41.3333333,130.444444 56.3111111,130.955556 58.6444444,120.244444 C61.5673549,119.908303 63.9243107,117.695835 64.4444444,114.8 L64.4444444,114.8 C67.2627887,114.792079 69.7716704,113.01273 70.7111111,110.355556 L71.1111111,110.355556 C74.7930094,110.355556 77.7777778,107.370787 77.7777778,103.688889 C77.7784507,102.82814 77.6124316,101.975405 77.2888889,101.177778 C81.4799666,100.139073 84.42867,96.3845124 84.4445801,92.0666667 Z"
              class="stroke"
              stroke-width="2.22222222"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-4)" />
            <g
              id="Group"
              mask="url(#mask-4)">
              <rect
                id="Rectangle"
                class="fill-light"
                fill-rule="nonzero"
                x="111.577778"
                y="31.4888889"
                width="88.8888889"
                height="92.2222222" />
              <polygon
                id="Path"
                class="fill-white"
                fill-rule="nonzero"
                points="111.577778 106.644444 186.733333 31.4888889 111.577778 31.4888889" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="111.577778"
                y="31.4888889"
                width="88.8888889"
                height="92.2222222" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="108.155556"
                y="21.4888889"
                width="94.4444444"
                height="10"
                rx="2.22222222" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="111.577778"
                y="93.7111111"
                width="88.8888889"
                height="6.66666667" />
              <path
                id="Path"
                d="M111.488889,109.266667 C110.746024,109.27108 110.003675,109.226539 109.266667,109.133333 L109.266667,119.266667 L113.711111,119.266667 L113.711111,109.111111 C112.973867,109.204531 112.231958,109.256465 111.488889,109.266667 Z"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M94.8222222,123.711111 L180.377778,123.711111 L180.377778,187.044444 L92.6,187.044444 L92.6,125.933333 C92.6,124.706034 93.5949228,123.711111 94.8222222,123.711111 Z"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <circle
                id="Oval"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                cx="111.488889"
                cy="91.4888889"
                r="17.7777778" />
              <circle
                id="Oval"
                class="fill-light"
                fill-rule="nonzero"
                cx="111.488889"
                cy="91.4888889"
                r="13.3333333" />
              <path
                id="Path"
                d="M111.488889,78.1553426 C106.005078,78.1979826 101.106523,81.5937624 99.1428261,86.7141019 C97.1791293,91.8344413 98.5508344,97.634923 102.6,101.333333 L121.422222,82.5111111 C118.877907,79.7172604 115.267604,78.1342189 111.488889,78.1553426 L111.488889,78.1553426 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <circle
                id="Oval"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round"
                cx="111.488889"
                cy="91.4888889"
                r="13.3333333" />
              <path
                id="Path"
                d="M103.711111,119.266667 L119.266667,119.266667 C120.493966,119.266667 121.488889,120.261589 121.488889,121.488889 L121.488889,123.711111 L101.488889,123.711111 L101.488889,121.488889 C101.488889,120.261589 102.483812,119.266667 103.711111,119.266667 Z"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="98.1555556"
                y="123.711111"
                width="82.2222222"
                height="38.8888889" />
              <rect
                id="Rectangle"
                class="stroke fill-light"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="98.1555556"
                y="123.711111"
                width="52.2222222"
                height="10" />
              <rect
                id="Rectangle"
                class="stroke fill-light"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="155.933333"
                y="123.711111"
                width="24.4444444"
                height="10" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="150.377778"
                y="123.711111"
                width="5.55555556"
                height="38.8888889" />
              <path
                id="Path"
                d="M112.6,149.266667 C110.759051,149.266667 109.266667,147.774282 109.266667,145.933333 C109.266667,144.092384 110.759051,142.6 112.6,142.6 C114.440949,142.6 115.933333,144.092384 115.933333,145.933333 C115.933333,147.774282 114.440949,149.266667 112.6,149.266667 L119.6,149.266667 C120.097375,148.224915 120.362741,147.087631 120.377778,145.933333 C120.377778,141.637785 116.895548,138.155556 112.6,138.155556 C108.304452,138.155556 104.822222,141.637785 104.822222,145.933333 C104.826965,147.08886 105.09285,148.228368 105.6,149.266667 L112.6,149.266667 Z"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M112.6,157.044444 C110.759051,157.044444 109.266667,155.55206 109.266667,153.711111 C109.266667,151.870162 110.759051,150.377778 112.6,150.377778 C114.440949,150.377778 115.933333,151.870162 115.933333,153.711111 C115.933333,155.55206 114.440949,157.044444 112.6,157.044444 L119.6,157.044444 C120.097375,156.002693 120.362741,154.865408 120.377778,153.711111 C120.377778,149.415563 116.895548,145.933333 112.6,145.933333 C108.304452,145.933333 104.822222,149.415563 104.822222,153.711111 C104.826965,154.866638 105.09285,156.006146 105.6,157.044444 L112.6,157.044444 Z"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="127.044444"
                y="139.266667"
                width="6.66666667"
                height="16.6666667"
                rx="2.22222222" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="138.155556"
                y="139.266667"
                width="6.66666667"
                height="16.6666667"
                rx="2.22222222" />
              <ellipse
                id="Oval"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                cx="165.377778"
                cy="147.044444"
                rx="3.88888889"
                ry="7.77777778" />
              <circle
                id="Oval"
                cx="89.2666667"
                cy="89.2666667"
                r="88.8888889" />
              <path
                id="Path"
                d="M65.9333333,149.266667 L32.6,149.266667 C32.2245456,149.261958 31.8512013,149.20969 31.4888889,149.111111 L31.4888889,158.155556 L67.0444444,158.155556 L67.0444444,149.111111 C66.6817644,149.207887 66.3086461,149.260124 65.9333333,149.266667 L65.9333333,149.266667 Z"
                class="stroke fill-light"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M97.0444444,153.711111 L89.2666667,153.711111 C87.583576,153.565147 85.9638853,152.999783 84.5555556,152.066667 L77.7777778,160.222222 C77.700373,160.321898 77.6107866,160.411484 77.5111111,160.488889 C80.9310578,162.989815 84.9606866,164.524912 89.1777778,164.933333 L96.9555556,164.933333 C100.023804,164.933333 102.511111,162.446026 102.511111,159.377778 C102.511111,156.309529 100.023804,153.822222 96.9555556,153.822222 L97.0444444,153.711111 Z"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M85.0444444,151.444444 C85.549474,150.818589 85.676956,149.968709 85.3777778,149.222222 C84.2724952,146.622209 83.7055313,143.825188 83.7111111,141 L83.7111111,134.822222 C83.7111111,115.799081 68.289808,100.377778 49.2666667,100.377778 C30.2435253,100.377778 14.8222222,115.799081 14.8222222,134.822222 L14.8222222,157.044444 L28.1555556,157.044444 L28.1555556,144.822222 C28.1555556,147.276821 30.1454011,149.266667 32.6,149.266667 L65.9333333,149.266667 C68.3879322,149.266667 70.3777778,147.276821 70.3777778,144.822222 C70.2835116,150.133711 71.6108074,155.373845 74.2222222,160 C74.6057659,160.587363 75.2441304,160.959139 75.9442633,161.002898 C76.6443963,161.046656 77.3240842,160.757258 77.7777778,160.222222 L85.0444444,151.444444 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M85.0444444,151.444444 C85.549474,150.818589 85.676956,149.968709 85.3777778,149.222222 C84.2724952,146.622209 83.7055313,143.825188 83.7111111,141 L83.7111111,134.822222 C83.7111111,115.799081 68.289808,100.377778 49.2666667,100.377778 C30.2435253,100.377778 14.8222222,115.799081 14.8222222,134.822222 L14.8222222,157.044444 L28.1555556,157.044444 L28.1555556,144.822222 C28.1555556,147.276821 30.1454011,149.266667 32.6,149.266667 L65.9333333,149.266667 C68.3879322,149.266667 70.3777778,147.276821 70.3777778,144.822222 C70.2835116,150.133711 71.6108074,155.373845 74.2222222,160 C74.6057659,160.587363 75.2441304,160.959139 75.9442633,161.002898 C76.6443963,161.046656 77.3240842,160.757258 77.7777778,160.222222 L85.0444444,151.444444 Z"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M41.4888889,93.7111111 L41.4888889,104.822222 C41.4888889,109.11777 44.9711186,112.6 49.2666667,112.6 C53.5622147,112.6 57.0444444,109.11777 57.0444444,104.822222 L57.0444444,93.7111111 L41.4888889,93.7111111 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M41.4888889,93.7111111 L41.4888889,104.822222 C41.4888889,109.11777 44.9711186,112.6 49.2666667,112.6 C53.5622147,112.6 57.0444444,109.11777 57.0444444,104.822222 L57.0444444,93.7111111 L41.4888889,93.7111111 Z"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="28.1555556"
                y1="130.377778"
                x2="28.1555556"
                y2="144.8"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="70.3777778"
                y1="130.377778"
                x2="70.3777778"
                y2="144.8"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M66.6666667,158.155556 L31.8222222,158.155556 C30.8420121,158.155484 29.9025819,158.547887 29.2136565,159.245163 C28.5247311,159.942439 28.1436742,160.886529 28.1555556,161.866667 C28.1151132,173.625425 28.8202312,185.374918 30.2666667,197.044444 L68.2444444,197.044444 C69.7334083,185.377792 70.4756601,173.627946 70.4669668,161.866667 C70.4795006,160.862968 70.0802915,159.897893 69.362162,159.196562 C68.6440326,158.495231 67.6697803,158.118972 66.6666667,158.155556 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M66.6666667,158.155556 L31.8222222,158.155556 C30.8420121,158.155484 29.9025819,158.547887 29.2136565,159.245163 C28.5247311,159.942439 28.1436742,160.886529 28.1555556,161.866667 C28.1151132,173.625425 28.8202312,185.374918 30.2666667,197.044444 L68.2444444,197.044444 C69.7334083,185.377792 70.4756601,173.627946 70.4669668,161.866667 C70.4795006,160.862968 70.0802915,159.897893 69.362162,159.196562 C68.6440326,158.495231 67.6697803,158.118972 66.6666667,158.155556 Z"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="49.1555556"
                y1="177.044444"
                x2="49.1555556"
                y2="197.044444"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M88.1555556,163.711111 C88.1555556,165.55206 89.6479397,167.044444 91.4888889,167.044444 L91.4888889,167.044444 C93.3298381,167.044444 94.8222222,165.55206 94.8222222,163.711111 L94.8222222,154.822222 C94.8222222,152.981273 93.3298381,151.488889 91.4888889,151.488889 L91.4888889,151.488889 C89.6479397,151.488889 88.1555556,152.981273 88.1555556,154.822222 L88.1555556,163.711111 Z"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M49.2666667,120.377778 C42.5828729,120.432484 36.255786,117.367544 32.1555556,112.088889 C35.1555556,121.555556 41.6888889,128.155556 49.2666667,128.155556 C56.8444444,128.155556 63.3555556,121.488889 66.3777778,112.088889 C62.2731316,117.362089 55.9489171,120.425637 49.2666667,120.377778 L49.2666667,120.377778 Z"
                class="stroke fill-light"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M66.3777778,112.088889 C67.6060643,110.476272 68.5803063,108.685166 69.2666667,106.777778"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M32.1555556,112.088889 C30.9121849,110.482452 29.9297622,108.690093 29.2444444,106.777778"
                class="stroke"
                stroke-width="2.22222222"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
            <path
              id="Path"
              d="M75.9333333,74.8222222 C75.9333333,77.2768211 73.9434878,79.2666667 71.4888889,79.2666667 L71.2222222,79.2666667 C69.5312884,90.0831163 60.2144901,98.0565805 49.2666667,98.0565805 C38.3188432,98.0565805 29.0020449,90.0831163 27.3111111,79.2666667 L27.0444444,79.2666667 C24.5898456,79.2666667 22.6,77.2768211 22.6,74.8222222 C22.6,72.3676233 24.5898456,70.3777778 27.0444444,70.3777778 L27.0444444,68.3555556 C32.7345395,67.9647022 38.0675787,65.4410319 41.9777778,61.2888889 C43.9932176,58.607756 45.686329,55.6988861 47.0222222,52.6222222 C48.645358,57.2355159 51.377319,61.3792446 54.9777778,64.6888889 C59.7264694,68.1661141 65.7206808,69.4811296 71.4888889,68.3111111 L71.4888889,70.5333333 C73.8840008,70.5318659 75.8495048,72.4285773 75.9333333,74.8222222 Z"
              class="stroke fill-white"
              stroke-width="2.22222222"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-4)" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              mask="url(#mask-4)"
              cx="36.4666667"
              cy="79.8"
              r="2.77777778" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              mask="url(#mask-4)"
              cx="62.0222222"
              cy="79.8"
              r="2.77777778" />
            <path
              id="Path"
              d="M55.9111111,85.4444444 C52.1915444,89.0342515 46.2973445,89.0342515 42.5777778,85.4444444"
              class="stroke"
              stroke-width="2.22222222"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-4)" />
            <path
              id="Path"
              d="M43.6888889,72.5777778 C43.1362608,71.2230368 41.8186758,70.3375163 40.3555556,70.3375163 C38.8924353,70.3375163 37.5748503,71.2230368 37.0222222,72.5777778"
              class="stroke"
              stroke-width="2.22222222"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-4)" />
            <path
              id="Path"
              d="M61.4666667,72.5777778 C60.8981723,71.2409558 59.5860132,70.3730825 58.1333333,70.3730825 C56.6806534,70.3730825 55.3684944,71.2409558 54.8,72.5777778"
              class="stroke"
              stroke-width="2.22222222"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-4)" />
            <path
              id="Path"
              d="M27.3111111,77 C27.3111111,77 26.1777778,88.1111111 25.0888889,89.2222222 C25.0888889,90.4495217 26.0838117,91.4444444 27.3111111,91.4444444 C28.5384106,91.4444444 29.5333333,90.4495217 29.5333333,89.2222222 C28.4,88.1111111 27.3111111,77 27.3111111,77 Z"
              class="stroke fill-white"
              stroke-width="2.22222222"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-4)" />
            <path
              id="Path"
              d="M71.1111111,77.0444444 C71.1111111,77.0444444 69.9777778,88.1555556 68.8888889,89.2666667 C68.8888889,90.4939661 69.8838117,91.4888889 71.1111111,91.4888889 C72.3384106,91.4888889 73.3333333,90.4939661 73.3333333,89.2666667 C72.2888889,88.1555556 71.1111111,77.0444444 71.1111111,77.0444444 Z"
              class="stroke fill-white"
              stroke-width="2.22222222"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-4)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
